import { BinderSectionData } from '../hooks/useBinderSectionData';
import { processPolicyData } from './policyProcessor';
import { processListedDriversData } from './listedDriversProcessor';
import { processListedVehiclesData } from './listedVehiclesProcessor';
import { processBillingData } from './billingProcessor';
import { APIBinderData } from 'types/api.types';

export const processUploadSummaryData = (
  binderReportData: APIBinderData,
): BinderSectionData => {
  const applicationData = binderReportData?.application_data;

  // Get the policy data as a sub-section
  const policyData = processPolicyData(applicationData);

  // Get the listed drivers data as a sub-section
  const listedDriversData = processListedDriversData(binderReportData);

  // Get the listed vehicles data as a sub-section
  const listedVehiclesData = processListedVehiclesData(binderReportData);

  // Get the billing data as a sub-section
  const billingData = processBillingData(binderReportData);

  return {
    title: 'Upload Summary',
    description: 'Summary of uploaded documents and policy information.',
    isValid: true,
    message: null,
    data: {
      policy: policyData, // Policy is a subsection of Upload Summary
      listedDrivers: listedDriversData, // Listed Drivers is a subsection of Upload Summary
      listedVehicles: listedVehiclesData, // Listed Vehicles is a subsection of Upload Summary
      billing: billingData, // Billing is a subsection of Upload Summary
    },
  };
};
